
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_17:17793)'><path d='M-0.0100098 7.72002V9.40002L2.98999 8.40002V18H4.98999V6.00002H4.73999L-0.0100098 7.72002ZM23.77 14.37C23.63 14.09 23.42 13.84 23.14 13.63C22.86 13.42 22.53 13.24 22.13 13.1C21.73 12.96 21.28 12.83 20.78 12.72C20.43 12.65 20.14 12.57 19.91 12.49C19.68 12.41 19.5 12.33 19.36 12.24C19.22 12.15 19.13 12.05 19.08 11.94C19.03 11.83 19 11.7 19 11.55C19 11.41 19.03 11.27 19.09 11.14C19.15 11.01 19.24 10.89 19.36 10.8C19.48 10.7 19.63 10.62 19.81 10.56C19.99 10.5 20.21 10.47 20.45 10.47C20.7 10.47 20.92 10.51 21.11 10.58C21.3 10.65 21.46 10.75 21.59 10.87C21.72 10.99 21.81 11.13 21.88 11.29C21.94 11.45 21.98 11.61 21.98 11.78H23.93C23.93 11.39 23.85 11.03 23.69 10.69C23.53 10.35 23.3 10.06 23 9.81002C22.7 9.56002 22.34 9.37002 21.91 9.22002C21.48 9.07002 20.99 9.00002 20.45 9.00002C19.94 9.00002 19.47 9.07002 19.06 9.21002C18.65 9.35002 18.29 9.54002 18 9.78002C17.71 10.02 17.49 10.3 17.33 10.62C17.17 10.94 17.1 11.27 17.1 11.63C17.1 11.99 17.18 12.32 17.33 12.59C17.48 12.87 17.69 13.11 17.97 13.32C18.24 13.53 18.57 13.7 18.95 13.85C19.33 13.99 19.76 14.11 20.22 14.21C20.61 14.29 20.93 14.38 21.17 14.47C21.41 14.56 21.6 14.66 21.74 14.76C21.87 14.86 21.96 14.98 22.01 15.1C22.06 15.22 22.08 15.35 22.08 15.49C22.08 15.81 21.95 16.06 21.68 16.26C21.41 16.46 21.02 16.55 20.51 16.55C20.29 16.55 20.08 16.53 19.87 16.47C19.66 16.42 19.47 16.34 19.31 16.23C19.14 16.12 19.01 15.97 18.9 15.79C18.79 15.61 18.73 15.38 18.72 15.12H16.83C16.83 15.48 16.91 15.83 17.07 16.17C17.23 16.51 17.46 16.82 17.77 17.1C18.08 17.37 18.46 17.59 18.92 17.76C19.38 17.93 19.9 18.01 20.5 18.01C21.03 18.01 21.51 17.95 21.94 17.82C22.37 17.69 22.74 17.51 23.05 17.28C23.36 17.05 23.59 16.77 23.76 16.45C23.93 16.13 24.01 15.78 24.01 15.39C23.99 14.99 23.92 14.65 23.77 14.37ZM13.81 7.05002C13.47 6.65002 13.06 6.35002 12.58 6.17002C12.11 5.99002 11.57 5.90002 10.99 5.90002C10.41 5.90002 9.87999 5.99002 9.39999 6.17002C8.91999 6.35002 8.50999 6.64002 8.16999 7.05002C7.82999 7.46002 7.56999 7.98002 7.37999 8.64002C7.19999 9.29002 7.09999 10.09 7.09999 11.03V12.95C7.09999 13.89 7.18999 14.69 7.37999 15.34C7.56999 16 7.82999 16.53 8.17999 16.94C8.51999 17.35 8.92999 17.65 9.40999 17.83C9.88999 18.01 10.42 18.11 11 18.11C11.59 18.11 12.12 18.02 12.59 17.83C13.07 17.65 13.47 17.35 13.81 16.94C14.15 16.53 14.41 16 14.59 15.34C14.77 14.69 14.87 13.89 14.87 12.95V11.03C14.87 10.09 14.78 9.29002 14.59 8.64002C14.41 7.98002 14.15 7.45002 13.81 7.05002ZM12.89 13.22C12.89 13.82 12.85 14.33 12.77 14.75C12.69 15.17 12.57 15.51 12.41 15.77C12.25 16.03 12.05 16.22 11.82 16.34C11.59 16.46 11.31 16.52 11 16.52C10.7 16.52 10.42 16.46 10.18 16.34C9.93999 16.22 9.73999 16.03 9.57999 15.77C9.41999 15.51 9.28999 15.17 9.19999 14.75C9.10999 14.33 9.06999 13.82 9.06999 13.22V10.72C9.06999 10.12 9.10999 9.61002 9.19999 9.20002C9.28999 8.79002 9.40999 8.46002 9.57999 8.20002C9.73999 7.95002 9.93999 7.77002 10.18 7.65002C10.42 7.54002 10.69 7.48002 10.99 7.48002C11.3 7.48002 11.57 7.54002 11.8 7.65002C12.04 7.76002 12.24 7.94002 12.4 8.20002C12.56 8.45002 12.69 8.78002 12.77 9.19002C12.85 9.60002 12.9 10.11 12.9 10.71V13.22H12.89Z' fill='#323232'/></g><defs><clipPath id='clip0_17:17793'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-timer-10`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTimer10

    ```js
    <b-new-b-icon-timer-10 />
    ```
</docs>


